import React, { useState, useCallback, useEffect } from 'react';
import { styled } from '@nykaa/ui-components';
import { logger } from '@nykaa/logger';
import CloseIcon from '@nykaa/ui-components/Icons/close';

import {
  handleCartNotificationOnclick,
  addWindowHandler,
  GamoogaNotificationProps,
} from '../../Notification/helpers';

interface Props {
  config: GamoogaNotificationProps | null;
  isDimissableTooltip?: boolean;
  handleTooltipClose?: () => void;
}

const Container = styled.div``;

const TooltipWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const IconWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacing.spacing40};
  display: flex;
  align-items: center;
  svg {
    path {
      fill: ${({ theme }) => theme.colors.surface};
    }
  }
`;

const TooltipText = styled.span`
  ${({ theme }) => theme.typography.bodySmall};
`;

export const useGamoogaData = () => {
  const [gamoogaNotification, setGamoogaNotification] = useState(null);
  const addHandler = useCallback(() => {
    addWindowHandler((params) => {
      try {
        setGamoogaNotification(params);
      } catch (error) {
        logger.error(error, 'error in gamooga call back');
      }
    });
  }, []);
  useEffect(() => {
    addHandler();
  }, [addHandler]);
  return gamoogaNotification;
};

function ToolTipContent({
  config,
  handleTooltipClose,
  isDimissableTooltip,
}: Props) {
  return (
    <>
      <Container
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleCartNotificationOnclick({
            gamoogaCartNotification: config,
          });
        }}
      >
        {isDimissableTooltip ? (
          <TooltipWrapper>
            <TooltipText>{config?.str}</TooltipText>
            <IconWrapper
              onClick={(event) => {
                event.stopPropagation();
                handleTooltipClose && handleTooltipClose();
              }}
            >
              <CloseIcon size="12px" />
            </IconWrapper>
          </TooltipWrapper>
        ) : (
          config?.str?.slice(0, 40)
        )}
      </Container>
    </>
  );
}

export default ToolTipContent;
